import axios from "axios";
import GlobalStoreHelper from "./GlobalStoreHelper";
import { CriteoCollectionPage } from "../../partials/criteo/_collectionPage";
import { CriteoShowcase } from "../../partials/criteo/_showcase";
import { CriteoFlagship } from "../../partials/criteo/_flagship";
import showCampaignsStickers from "../../partials/collection/_showCampaignStickers";

const criteoCollectionPage = new CriteoCollectionPage();
const criteoShowcase = new CriteoShowcase(false); // Set to false to disable debug logs
const criteoFlagship = new CriteoFlagship(false);

class CollectionPage {
  #freeShiippingSettings;

  constructor() {
    this.#freeShiippingSettings = window.freeShipping;
  }

  /**
   * Formats the stock information about the product in the way which suits
   * catalogue page output.
   * @param {array<object>} item stock information for the product
   * @param {object} locSelected The info of the location that is selected
   * @returns string
   */
  async messageDiv(item, locSelected) {
    const { show, minAmount, collectionsExcludedWithTitles, label } =
      this.#freeShiippingSettings;
    const locationId = GlobalStoreHelper.getItem("locationId");
    const productCard = document.querySelector(
      `#snize-product-${item[0].productId}`,
    );
    const tags = Array.from(productCard.classList || []);
    const warehouseTag = !!tags.find((tag) => tag.includes("warehouse-15"));
    const peninsulaStockTag = !!Array.from(tags).find((tag) =>
      tag.includes("peninsula-stock"),
    );
    const noEnvioTag = !!tags.find(
      (tag) => tag === "snize-product-tag-no_envio",
    );
    const isReleaseUnknow = !!tags.find((tag) => {
      const regex = new RegExp(/snize-product-tag-(presale-noprevision).*/);

      return !!tag.match(regex)?.length;
    });

    const labelInfo = await GlobalStoreHelper.createPromiseObject(item, {
      locationId,
      addStoreSelector: true,
      skipDate: true,
      appendStoreName: true,
      newLine: false,
      productId: item[0] ? item[0].productId : null,
      isPLP: true,
      locSelectedIsWarehouse15: !!locSelected?.wareHouse15,
      warehouseTag,
      peninsulaStockTag,
      isReleaseUnknow,
      noEnvioTag,
    });

    const collectionsTitles =
      productCard.dataset?.collectionsTitles?.split(";");
    const price = Number(
      productCard
        .querySelector(".snize-price-list .bigpricesrc")
        ?.innerHTML.replace(",", "."),
    );
    const safeStockTags = Array.from(tags)
      .filter((tag) => tag.includes("safe-stock"))
      .map((tag) => {
        const [_, storeName] = tag.split("_");

        return storeName.toUpperCase().replace("-", "");
      });

    let additional = "";
    let online = "";
    let store = "";
    let freeShippingMarkup = ` - <b>${label}</b>`;

    const priceInRange = price > minAmount;
    const collectionExcluded = !!collectionsExcludedWithTitles.find(
      (collection) => collectionsTitles.includes(collection.title),
    );

    if (isReleaseUnknow) {
      additional = `
                <div class="stock-at-location">
                    <div class="stock-text">
                        ${window.promises.release_unknown}
                    </div>
                </div>
            `;
    }

    if (
      !noEnvioTag &&
      labelInfo.online.color === "grey" &&
      safeStockTags?.length
    ) {
      online = `
                <div class="stock-at-location online">
                    <div class="bubble orange"></div>
                    <div class="stock-text" >
                        ${window.check_disponibility_label} <a href="#" data-safe-stock-tags-${item[0].productId}="${safeStockTags.join(",")}" onClick="storePickup.storeModal.toggleStoreSelector(${item[0].productId});">aqui</a>.
                    </div>
                </div>
            `;

      productCard.classList.remove("snize-product-out-of-stock");
      productCard.classList.add("snize-product-safe-stock");
    } else {
      if (labelInfo.online.message) {
        online = `
                <div class="stock-at-location online">
                    <div class="bubble ${labelInfo.online.color}"></div>
                    <div class="stock-text">${labelInfo.online.message}${show && priceInRange && !collectionExcluded ? freeShippingMarkup : ""}</div>
                </div>
                `;
      }

      if (labelInfo.store.message) {
        store = `
                <div class="stock-at-location store">
                    <div class="bubble ${labelInfo.store.color}"></div>
                    <div class="stock-text">${labelInfo.store.message}${labelInfo.store.color !== "grey" ? freeShippingMarkup : ""}</div>
                </div>
            `;
        `;
                `;
      }
    }
    return additional + online + store;
  }

  retrieveThemeConfiguration() {
    const modalConfigs = document.querySelector("#list-of-stores-wrap");
    return modalConfigs.dataset;
  }

  /**
   * Entry point for stock information retrieval, channeled through timeout logic,
   * to prevent excessive calls to API, when resizing browser, since that triggers
   * update event on catalogue app.
   */
  outputStockInfo() {
    // In case store delivery is disabled, abort
    const parentMobDom = document.querySelector(".store-selector-mobile");
    if (!parentMobDom) return;

    const colPage = this;

    if (this.reloadTimeout) {
      clearTimeout(this.reloadTimeout);
      this.reloadTimeout = setTimeout(function () {
        colPage.findItems();
      }, 500);
    } else {
      this.reloadTimeout = setTimeout(function () {}, 500);
      colPage.findItems();
    }
  }

  /**
   * Collect all product ids from visible catalogue items and fetch their available stock,
   * afterwards fill this information in.
   */

  async findItems() {
    const template = mmkt.core.pathLocation.getSection();
    if (!this.criteoBusy) {
      this.criteoBusy = true;
      const criteoPromise = (async () => {
        try {
          await criteoCollectionPage.exec(template);
          const criteoResponse = criteoCollectionPage.getResponse();
          if (criteoResponse) {
            criteoShowcase.setResponse(criteoResponse);
            criteoFlagship.setResponse(criteoResponse);
          }
          const { showShowcase, showFlagship } = window.criteoSettings || {};

          if (showShowcase !== false) {
            await criteoShowcase.exec(template);
          }

          if (showFlagship !== false) {
            await criteoFlagship.exec(template);
          }
        } catch (e) {
          console.log(e);
        } finally {
          this.criteoBusy = false;
        }
      })();
    }

    const productIds = [];
    const products = document.querySelectorAll(".snize-product");

    for (const product of products) {
      const prodElemId = product.id;
      if (prodElemId && !prodElemId.includes("criteo")) {
        const prodId = prodElemId.replace(/^\D+/g, "");
        productIds.push(prodId);
      }
    }

    const locationId = GlobalStoreHelper.getItem("locationId");

    if (productIds.length > 0) {
      const requestData = {
        productsIds: productIds,
        requestedQty: productIds.map((productId) => {
          return {
            productId,
            qty: 1,
          };
        }),
      };
      const data = await GlobalStoreHelper.request({
        service: `locations/${locationId}/stock-at-products`,
        method: "POST",
        body: requestData,
      });
      await this.populateItemsWithInfo(data);
    }

    showCampaignsStickers();
  }

  /**
   * Iterates over received stock availability and provides appropriate promises to
   * catalogue items.
   * @param {object} response with stock availability
   */
  async populateItemsWithInfo(response) {
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    const stock = response.map((item) => item.productId).filter(onlyUnique);
    const configs = this.retrieveThemeConfiguration();

    // If disabled in theme settings, then abort execution
    if (
      configs.hidePhysicalStorePromises &&
      configs.hidePhysicalStorePromises === "true"
    ) {
      return;
    }

    const locationId = GlobalStoreHelper.getItem("locationId");

    const locations = await GlobalStoreHelper.request({
      service: `locations/pickups/work-times`,
      cache: true,
    });
    const locationSelected = locations.find(
      (loc) => loc.locationId == locationId,
    );

    for (const item of stock) {
      const existingMessage = document.querySelector(
        `#snize-product-${item} .stock-message`,
      );
      const productWrap = document.querySelector(
        `#snize-product-${item} .snize-item`,
      );

      if (productWrap) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("row", "stock-message");

        const beforeDiv = document.querySelector(
          `#snize-product-${item} .snize-overhidden`,
        );
        if (!existingMessage) productWrap.insertBefore(newDiv, beforeDiv);

        document.querySelector(
          `#snize-product-${item} .stock-message`,
        ).innerHTML = await this.messageDiv(
          response.filter((product) => product.productId === item),
          locationSelected,
        );
      }
    }

    /**
     * @type {HTMLUListElement}
     */
    const productGrid = document.querySelector(
      "ul.snize-search-results-content.clearfix",
    );

    let lastWithStock = 0;

    const cardsToMove = [];

    productGrid.childNodes.forEach((card, i) => {
      const outOfStock = card.classList.contains("snize-product-out-of-stock");
      const isSafeStock = card.classList.contains("snize-product-safe-stock");

      if (!outOfStock && !isSafeStock && i > lastWithStock) lastWithStock = i;

      if (isSafeStock) cardsToMove.push(i);
    });

    cardsToMove.forEach((index) => {
      productGrid.insertBefore(
        productGrid.childNodes.item(index),
        productGrid.childNodes.item(lastWithStock + 1),
      );
    });
  }
}

export default CollectionPage;
